/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_S1Inputs */

const en_tut_akses_s1 = /** @type {(inputs: Tut_Akses_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The area's creator presses **Akses area** on the room card and picks **Semua anggota workspace**, **Undangan manual**, or **Anggota divisi terkait**.`)
};

const id_tut_akses_s1 = /** @type {(inputs: Tut_Akses_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembuat area menekan **Akses area** pada kartu ruang, lalu memilih **Semua anggota workspace**, **Undangan manual**, atau **Anggota divisi terkait**.`)
};

/**
* | output |
* | --- |
* | "The area's creator presses **Akses area** on the room card and picks **Semua anggota workspace**, **Undangan manual**, or **Anggota divisi terkait**." |
*
* @param {Tut_Akses_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_s1 = /** @type {((inputs?: Tut_Akses_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_s1(inputs)
	return en_tut_akses_s1(inputs)
});